import React from 'react';
import * as Styled from './ADigit.styles';
import { ADigitSize, type ADigitProps } from './ADigit.types';

const COMPONENT_NAME = 'a-web-ui-kit-ADigit';
const TEST_ID = 'web-ui-kit-ADigit';

function ADigit({ size = ADigitSize.Small, text, ...rest }: ADigitProps) {
  return (
    <Styled.ADigitWrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} size={size} {...rest}>
      {text}
    </Styled.ADigitWrapper>
  );
}

export { ADigit, ADigitSize, TEST_ID as A_DIGIT_TEST_ID };
